import { render, staticRenderFns } from "./ship_itemDetail_dialog.vue?vue&type=template&id=0c5cfb40"
import script from "./ship_itemDetail_dialog.vue?vue&type=script&lang=js"
export * from "./ship_itemDetail_dialog.vue?vue&type=script&lang=js"
import style0 from "./ship_itemDetail_dialog.vue?vue&type=style&index=0&id=0c5cfb40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports